import { lazy, Suspense } from 'react';
import { ErrorBoundary } from '@gonfalon/error-boundaries/ErrorBoundary';
import { QueryErrorResetBoundary } from '@tanstack/react-query';

import type { CodeEditorProps } from './internal/CodeEditor';
import { CodeEditorFallback } from './internal/CodeEditorFallback';
import { CodeEditorRetryFallback } from './internal/CodeEditorRetryFallback';

const CodeEditor = lazy(async () =>
  import(/* webpackChunkName: "CodeEditor" */ './internal/CodeEditor').then((module) => ({
    default: module.CodeEditor,
  })),
);

export const LazyCodeEditor = (props: CodeEditorProps) => (
  <QueryErrorResetBoundary>
    {({ reset }) => (
      <ErrorBoundary
        severity="medium"
        onReset={reset}
        fallbackRender={({ resetErrorBoundary }) => <CodeEditorRetryFallback resetErrorBoundary={resetErrorBoundary} />}
      >
        <Suspense fallback={<CodeEditorFallback />}>
          <CodeEditor {...props} />
        </Suspense>
      </ErrorBoundary>
    )}
  </QueryErrorResetBoundary>
);
